import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login.service';
import { UsuarioLoginEntity, UsuarioRespuestaEntity } from './usuario_login_entity';
import { HandleError } from "../../components/common/utils/handleError.component";
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { ClienteLogin } from "./cliente_login";
import { UsuarioRegistroEntity } from "../register/entities/usuario_registro_entity";
import { verificarUsuarioComponent } from "./verificar-usuario.component";
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { UtilService } from "../../components/common/utils/util.service";
import { ShowHideInput, ShowHideInput2 } from "./show-hide-input.directive";

declare var jQuery: any;
const swal = require("sweetalert2");

@Component({
    selector: 'nuevaContrasena',
    templateUrl: 'nueva-contrasena.template.html'
})
export class nuevaContrasenaComponent implements OnChanges {
    usuarioRegistro: UsuarioRegistroEntity;
    usuarioLogin: UsuarioLoginEntity;    
    errorMessage: string;
    showLoader: string;
    banderaBrowser: number;
    banderaIE: boolean;
    private sub: any;
    @SessionStorage("usuario")
    user: any;
    @SessionStorage("usuarioLogin")
    userLogin: any;
    @SessionStorage("Token")
    Token: any;
    esCliente: boolean;
    @Input() usuarioRespuesta: UsuarioRespuestaEntity;
    showUsuario: boolean;
    showPregunta: boolean;

    @ViewChild(ShowHideInput)
    input: ShowHideInput;

    @ViewChild(ShowHideInput2)
    input2: ShowHideInput2;

    show = false;
    show2 = false;
    bandera: number;
 
    constructor(
        private sessionStorageService: SessionStorageService,
        private loginService: LoginService,
        private route: ActivatedRoute,
        private router: Router,
        private handleError: HandleError,
        public utilService: UtilService
    ) {
        this.showUsuario = false;
        this.showPregunta = true;
    }

    cambiaContrasena() {
        this.usuarioRespuesta.OtraContrasena = "";        
    }

    toggleShow(e: any, campo: number) {
        if (campo == 1) {
            this.show = !this.show;

            if (this.show) {
                this.input.changeType("text");
            }
            else {
                this.input.changeType("password");
            }
        }
        else if (campo == 2) {
            this.show2 = !this.show2;

            if (this.show2) {
                this.input2.changeType("text");
            }
            else {
                this.input2.changeType("password");
            }
        }
    }

    checkBrowser() {
        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        //console.log(ua);
        if (msie > 0) {
            // IE 10 or older => return version number
            //return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            this.banderaIE = true;
        } else {

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                //return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                this.banderaIE = true;
            } else {
                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    //return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                    this.banderaIE = false;
                } else {
                    // other browser
                    //return false;
                    this.banderaIE = false;
                }
            }
        }
    }

    ngOnChanges(): void {

        this.checkBrowser();
        this.banderaBrowser = 0;
        this.usuarioLogin = new UsuarioLoginEntity();

        this.sub = this.route.params.subscribe(params => {
            this.bandera = +params['bandera'];
            if (this.bandera != 1 && this.bandera != 2) {
                this.router.navigate(["/error404"]);
            }
            this.banderaBrowser = this.bandera;
        });        
    }

    irInicio() {
        this.router.navigate(['/login', this.banderaBrowser]);
    }    
    
    actualizarContrasena() {        
        this.loginService.actualizarContrasena(this.usuarioRespuesta).subscribe(
            actualizacionExitosa => {                
                if(actualizacionExitosa)
                {   
                    swal({
                        title: 'Cambio de contraseña',
                        text: 'Su contraseña se ha actualizado con éxito. A continuación puede ingresar a nuestro sistema',
                        type: 'success',
                        confirmButtonColor: '#A14950',
                        confirmButtonText: 'Aceptar'                                                                
                        });                         
                        this.router.navigate(['/login', this.banderaBrowser]);            
                }
                else
                {                  
                    this.showLoader = "";
                    swal({
                        title: 'Cambio de contraseña',
                        text: "No se ha realizado el cambio de contraseña, contactese con su ejecutivo.",
                        type: 'error'
                    });
                }  
                
            },
            error => {
                this.handleError.redirectUrl(error)
            }
        );
    } 

}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/nueva-contrasena.component.ts